export const downloadDocument = (url: string) => {
  window.open(url, '_blank');
};
